const API_BASE_URL = process.env.REACT_APP_API_URL;
const USER_ENDPOINT = `${API_BASE_URL}auth/usuarios`;

export const createUser = async (userData) => {
  try {
    const tokenTemporal = localStorage.getItem('tempAuthToken'); 
    if (!tokenTemporal) {
      console.error('Token temporal no encontrado.');
      return { success: false, message: 'Token temporal no encontrado. Por favor, complete el paso anterior.' };
    }

    const dataToSend = {
      ...userData,
      tokenTemporal: tokenTemporal
    };

    const response = await fetch(USER_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataToSend),
    });
    
    localStorage.removeItem('tempAuthToken');

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error en la petición de creación de usuario:', response.status, errorData);
      return { success: false, message: errorData.message || 'Error al crear el usuario.' };
    }

    const responseData = await response.json();
    return { success: true, data: responseData };

  } catch (error) {
    console.error('Error al crear el usuario:', error);
    localStorage.removeItem('tempAuthToken');
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getJefes = async () => {
  try {
    const token = localStorage.getItem('authToken');
    const headers = {
        'Content-Type': 'application/json',
    };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}admin/usuarios/jefes`, {
      method: 'GET',
      headers: headers,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error al obtener la lista de jefes:', errorData.message);
      return [];
    }

    return await response.json();

  } catch (error) {
    console.error('Error de conexión al obtener la lista de jefes:', error);
    return [];
  }
};

export const getUsuarios = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Se requiere autenticación para esta operación.' };
    }

    const response = await fetch(`${API_BASE_URL}auth/usuarios`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error al obtener la lista de usuarios:', errorData.message);
      return { success: false, message: errorData.message || 'Error del servidor' };
    }

    const data = await response.json();
    return { success: true, data };

  } catch (error) {
    console.error('Error de conexión al obtener la lista de usuarios:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const cambiarEstadoUsuario = async (idUsuario, nuevoEstado) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Se requiere autenticación para esta operación.' };
    }

    const response = await fetch(`${API_BASE_URL}auth/usuarios/${idUsuario}/estado`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ estado: nuevoEstado }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error al cambiar el estado del usuario:', errorData.message);
      return { success: false, message: errorData.message || 'Error del servidor' };
    }

    return { success: true };

  } catch (error) {
    console.error('Error de conexión al cambiar el estado del usuario:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getUsuarioPorDocumento = async (numeroDocumento) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Se requiere autenticación para esta operación.' };
    }

    const response = await fetch(`${API_BASE_URL}auth/usuarios/documento/${numeroDocumento}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        return { success: false, message: 'Usuario no encontrado.' };
      }
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error al buscar el usuario:', errorData.message);
      return { success: false, message: errorData.message || 'Error del servidor' };
    }

    const data = await response.json();
    return { success: true, data };

  } catch (error) {
    console.error('Error de conexión al buscar el usuario:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 

export const actualizarInfoLaboral = async (idUsuario, infoLaboral) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Se requiere autenticación para esta operación.' };
    }

    // Preparar el JSON solo con los campos que se envían (evitar nulls)
    const requestBody = {};
    
    if (infoLaboral.rolId !== undefined && infoLaboral.rolId !== null) {
      requestBody.rolId = infoLaboral.rolId;
    }
    
    if (infoLaboral.jefeInmediatoId !== undefined && infoLaboral.jefeInmediatoId !== null) {
      requestBody.jefeInmediatoId = infoLaboral.jefeInmediatoId;
    }
    
    if (infoLaboral.areaId !== undefined && infoLaboral.areaId !== null) {
      requestBody.areaId = infoLaboral.areaId;
    }

    console.log('Enviando datos:', requestBody); // Para debugging

    const response = await fetch(`${API_BASE_URL}auth/usuarios/${idUsuario}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error al actualizar la información laboral:', errorData.message);
      return { success: false, message: errorData.message || 'Error del servidor' };
    }

    const data = await response.json();
    return { success: true, data };

  } catch (error) {
    console.error('Error de conexión al actualizar la información laboral:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 

export const actualizarInfoPersonal = async (infoPersonalId, infoPersonal) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Se requiere autenticación para esta operación.' };
    }

    // Preparar el JSON con los datos a actualizar
    const requestBody = {
      nombres: infoPersonal.nombres,
      apellidos: infoPersonal.apellidos,
      tipoDocumentoId: infoPersonal.tipoDocumentoId,
      numeroDocumento: infoPersonal.numeroDocumento,
      celular: infoPersonal.celular,
      email: infoPersonal.email
    };

    console.log('Enviando datos de info personal:', requestBody); // Para debugging

    const response = await fetch(`${API_BASE_URL}info-personal/${infoPersonalId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Error al actualizar la información personal:', errorData.message);
      return { success: false, message: errorData.message || 'Error del servidor' };
    }

    const data = await response.json();
    return { success: true, data };

  } catch (error) {
    console.error('Error de conexión al actualizar la información personal:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 